import { useState } from "react";
import useLenis from "@/hooks/useLenis";
import Preloader from "@/components/site/Preloader";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import PortraitServices from "@/components/site/PortraitServices";
import Philosophy from "@/components/site/Philosophy";
import VIP from "@/components/site/VIP";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  useLenis();
  const [ready, setReady] = useState(false);

  return (
    <>
      <Preloader onDone={() => setReady(true)} />
      <main
        data-testid="landing-root"
        className="relative bg-onyx text-cream font-sans font-light selection:bg-brass selection:text-onyx"
      >
        <Nav />
        <Hero ready={ready} />
        <Philosophy />
        <PortraitServices />
        <VIP />
        <Contact />
        <Footer />
      </main>
    </>
  );
}
